module.exports = __webpack_public_path__ + "img/oem.22f4d84e.png";